import { rem } from 'polished'
import styled from 'styled-components'

export const PageLimitSelectStyled = styled.span`
  width: ${rem(70)};
  font-family: inherit;
  font-size: ${rem(12)};
`
